import { Box, VStack, Button, useToast, Spinner } from "@chakra-ui/react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { TextAreaInput, TextInput } from "../../components/forms";
import { postData } from "../../utilities/axios";
import * as N from "../../utilities/notifications";

const BookingRequestForm = (props) => {
  const toast = useToast();

  // initial state
  const user = useSelector((state) => state.user.userDetails);
  const token = useSelector((state) => state.user.JWTToken);
  const formBookingRequest = useRef();
  const [loading, setLoading] = useState(false);

  // SUBMIT FORM
  const handleSubmit = (values, setSubmitting) => {
    if (loading) {
      return;
    }

    setSubmitting(true);
    setLoading(true);
    const urlRegex =
      /\b((https?:\/\/|www\.)[^\s<>"']+|[a-z0-9.-]+\.[a-z]{2,63}[^\s<>"']*|(?:\d{1,3}\.){3}\d{1,3}(?::\d+)?[^\s<>"']*|localhost(?::\d+)?[^\s<>"']*)/gi;
    if (urlRegex.test(values.prescreen)) {
      console.log("rejected for url");
      toast(
        N.genericFail(
          "Links can't be sent through this platform",
          "For everyone's safety, please remove any links in your message",
        ),
      );
      setLoading(false);
      setSubmitting(false);
      return;
    }
    try {
      postData(
        token,
        values,
        `${process.env.NEXT_PUBLIC_NEW_BOOKING_URL}request`,
        process.env.NEXT_PUBLIC_NEW_BOOKING_APIKEY,
      ).then((data) => {
        if (data.duplicate) {
          props.setBookingMade({
            duplicate: data.duplicate,
            name: props.practitionerName,
          });
        } else {
          props.setBookingMade({ name: props.practitionerName });
        }
        setLoading(false);
      });
    } catch (error) {
      console.error("ERROR making booking", error);
      toast(N.genericFail("Failed to make booking"));
      setLoading(false);
    } finally {
      setSubmitting(false);
    }
  };

  // Render
  return (
    <Formik
      innerRef={formBookingRequest}
      initialValues={{
        practitionerId: props.practitionerId,
        profileId: props.profileId,
        practitionerType: props.practitionerType,
        patientName: user.fullname,
        patientEmail: user.email,
        patientNumber: user.contactPhone || "",
        prescreen: "",
      }}
      validationSchema={Yup.object({
        patientName: Yup.string().required("Name required"),
        patientEmail: Yup.string().email().required("Email required"),
        prescreen: Yup.string().required("Message required"),
      })}
      onSubmit={(values, { setSubmitting }) => {
        setLoading(true);
        handleSubmit(values, setSubmitting);
      }}
    >
      {(formik) => (
        <>
          <Box width="100%" mx="auto" mb="20px">
            <VStack
              as="form"
              maxW="full"
              spacing={8}
              alignItems="flex-start"
              bg="white"
              onSubmit={formik.handleSubmit}
              overflow="hidden"
            >
              <TextInput
                name="patientName"
                formlabel="Your name"
                type="text"
                placeholder="Robin"
                disabled
              />

              <Box
                display={{ base: "block", md: "flex" }}
                w="100%"
                justifyContent="space-between"
              >
                <Box w={{ base: "100%", md: "48%" }} mt={[4, 4, 0]}>
                  <TextInput
                    name="patientEmail"
                    formlabel="Your email"
                    type="email"
                    placeholder="e.g. robin@yourmail.com"
                    disabled
                  />
                </Box>
                <Box w={{ base: "100%", md: "48%" }} mt={[4, 4, 0]}>
                  <TextInput
                    name="patientNumber"
                    formlabel="Your phone number"
                    type="tel"
                    placeholder="Landline or mobile number"
                    disabled={!!user.contactPhone}
                  />
                </Box>
              </Box>

              <TextAreaInput
                bg="brand.100"
                width="100%"
                name="prescreen"
                formlabel="Message to therapist"
                resize="vertical"
                height="200px"
                placeholder="Use this space to tell your chosen therapist a bit about who you are and your reasons for seeking therapy. This form must only by used for counselling enquiries."
              />
              <Box w="100%" display="flex" justifyContent="space-between">
                <Button
                  w="48%"
                  variant="outline"
                  onClick={() => {
                    props.close();
                  }}
                >
                  Close
                </Button>

                <Button
                  id="therapist-contact-form"
                  w="48%"
                  type="submit"
                  isLoading={formik.isSubmitting}
                  loadingText="Submitting booking"
                  className={`transition-all flex items-center gap-2 ${loading ? "opacity-[0.7]" : "opacity-[1]"}`}
                >
                  {loading && <Spinner className="text-white" size="xs" />}
                  Send{loading && "ing"}
                </Button>
              </Box>
            </VStack>
          </Box>
        </>
      )}
    </Formik>
  );
};

export default BookingRequestForm;
